import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import AppInmobiliaria from '@/components/AppInmobiliaria'
import PageNotFound from '@/components/PageNotFound'
import AppInmueble from '@/components/AppInmueble'
//import Mapa from '@/components/Mapa'
import Contact from '@/components/Contact'
import VueHead from 'vue-head'

Vue.use(VueHead)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/inmobiliarias',
      name: 'Inmobiliarias',
      component: AppInmobiliaria
    },
	{
      path: '/propiedad/:id',
      name: 'AppInmuebleView',
      component: AppInmueble
    },
	/*
	{
      path: '/mapa',
      name: 'Mapa',
      component: Mapa
    },
	*/
	{
      path: '/contacto',
      name: 'Contacto',
      component: Contact
    },
	{ path: "*", component: PageNotFound }
  ],
  scrollBehavior (to, from, savedPosition) {
	return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js